module.exports = "https://cdn.thelire.com/ins/resource/right-hand.958fb61e96cb6b92ddc8664d997770a6.png";